import { AxiosObservable } from '@cbridge-utils/axios-observable';
import { ApiServiceType, BaseService } from '@cbridge-packages/api-base';
import { IApiGetTriggeredAlertsReq, IApiGetTriggeredAlertsRes } from '../_interfaces/notifications/IApiGetTriggeredAlerts';
import { IApiUpdateSubscriptionReq } from '../_interfaces/notifications/IApiUpdateSubscription';
import { IApiGetSubscriptionsRes } from '../_interfaces/notifications/IApiGetSubscriptions';
import { IApiAddEmailToSubscriptionReq } from '../_interfaces/notifications/IApiAddEmailToSubscription';
import { IApiUpdateEmailsReq } from '../_interfaces/notifications/IApiUpdateEmails';
import { ApiAlertType } from '../_entities/IApiTriggeredAlert';

export class NotificationApiService extends BaseService {
  constructor() {
    super(ApiServiceType.Notification);
  }

  getTriggeredAlerts(payload: IApiGetTriggeredAlertsReq): AxiosObservable<IApiGetTriggeredAlertsRes> {
    return this.api.get<IApiGetTriggeredAlertsRes>('/triggered-alerts', { params: payload });
  }

  getSubscriptions(): AxiosObservable<IApiGetSubscriptionsRes> {
    return this.api.get<IApiGetSubscriptionsRes>('/subscriptions');
  }

  updateSubscription(type: ApiAlertType, payload: IApiUpdateSubscriptionReq): AxiosObservable<void> {
    return this.api.put<void>(`/subscriptions/${type}`, payload);
  }

  addEmailToSubscription(type: ApiAlertType, payload: IApiAddEmailToSubscriptionReq): AxiosObservable<void> {
    return this.api.post<void>(`/subscriptions/${type}/email`, payload);
  }

  updateEmails(payload: IApiUpdateEmailsReq): AxiosObservable<void> {
    return this.api.post<void>('/emails', payload);
  }
}
